import { Component, OnInit, ViewEncapsulation, Input, HostListener } from '@angular/core';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeUrl  } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';

@Component({
	selector      : 'app-event-detail',
	templateUrl   : './event-detail.component.html',
	encapsulation : ViewEncapsulation.None
})

export class EventDetailComponent implements OnInit {
	@Input() scheduleTags     : any;
	@Input() scheduleSessions : any;
	@Input() week_day_name    : any;
	@Input() week_day_id      : any;
	@Input() tag_list_name    : any = [];
	@Input() tag_list_id      : any = [];
	@Input() content_type     : any;
	public video_url?: SafeUrl;
	public breadCrumbData     : any = [];
	public scheduleDotNetData : any = [];
	public leftConvenor       : any = [];
	public rightConvenor      : any = [];
	public detail           : any;
	public detail_tags      : any;
	public day              : any;
	public time             : any;
	public current_url_slug : any;
	public back_to_url      : any;
	public description      : any;
	public eventTypeClass   = '';
	public goldClass        = '';
	public opensessionClass = '';
	public showSelectedtags    : boolean = false;
	public showSelectedgold    : boolean = false;
	public showOpensession     : boolean = false;
	public showSelecteddays    : boolean = false;
	public showSelectedsession : boolean = false;
	public tagsAll             : boolean = true;
	public daysAll             : boolean = true;
	public sessionAll          : boolean = true;
	public loadButton          : boolean = true;	

	constructor(
		private _location      : Location,
		private sanitizer      : DomSanitizer,
		private router         : Router,
		private titleService   : Title,
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
	) {
		window.location.href = "https://trippus.net/worldwaterweek2023";
		return;
		/* routing */
		this.router.routeReuseStrategy.shouldReuseRoute = function () {
      		return false; 
    	};
    	/* routing */    	
		if ( 'userData' in window.localStorage ) {
			var userData = JSON.parse( window.localStorage.getItem( 'userData' ) );
			this.shareddata.setUserSession( userData );
		}
		let timezone = '';
		if ( 'filterProgrammeKeys' in window.sessionStorage ) {
			let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterProgrammeKeys' ) );
			timezone = localSessionItems.timezone;
		} else {
			timezone = 'W. Europe Standard Time';
		}
		let current_slug      = window.location.pathname.split("/").slice(-1)[0];
		let current_slug_id   = current_slug.split( '-' )[0];
		let params = {
			'id' : current_slug_id,
			'timezone' : timezone,
		};
		sessionStorage.setItem( 'clickedEventDetailId', JSON.stringify( current_slug_id ) );
		this.accountService.getProgrameDetail( params ).then( ( result: any ) => {
			let response = result;
			if ( response['status'] == 'Ok' ) {
				this.titleService.setTitle( response['programmeDetail'].title + ' | ' + response['programmeDetail'].eventType );
				let wp_params;
				this.detail = response['programmeDetail'];
				if ( '' !== this.detail.description )
					this.description =  this.detail.description;
				this.detail_tags = this.detail.tags;
				this.content_type = this.detail.eventType;
				if ( this.detail.convenors.length > 0 ) {
					var convenor_count = this.detail.convenors.length;
					var convenor_half_count = Math.round( convenor_count / 2 );
					var leftConvenor = [];
					var rightConvenor = [];
					if ( 1 == convenor_count )
						leftConvenor.push( this.detail.convenors[0] );
					if( 1 < convenor_count ) {
						this.detail.convenors.forEach( function ( a, b ){
							if ( b < convenor_half_count )
								leftConvenor.push( a );
							else
								rightConvenor.push( a );
						});
					}
					if ( null != this.detail.otherConvenor ) {
						if ( leftConvenor.length > rightConvenor.length ) {
							rightConvenor.push( {'name': this.detail.otherConvenor} );
						} else {
							leftConvenor.push( {'name': this.detail.otherConvenor} );
						}					
					}
					this.leftConvenor = leftConvenor;
					this.rightConvenor = rightConvenor;
				}
				if ( this.detail.videoLink != null ) {
					let url = 'https://www.youtube.com/embed/' + this.detail.videoLink.split( '?v=' )[1];
					this.video_url = this.sanitizer.bypassSecurityTrustResourceUrl( url );
				}				
				var interval_arr = this.detail.dateInterval.split( '|' );
				this.day  = interval_arr[0];
				this.time = interval_arr[1];
				this.current_url_slug = document.location.href;
				if ( 'filterProgrammeKeys' in window.sessionStorage ) {
					let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterProgrammeKeys' ) );
					if ( 0 != localSessionItems.tag_id )
						this.tagsAll = false;
					if ( 0 != localSessionItems.session_id )
						this.sessionAll = false;
					if ( 0 != localSessionItems.goldstandard )
						this.showSelectedgold = true;
					if ( 0 != localSessionItems.opensession )
						this.showOpensession = true;
					if ( 0 != localSessionItems.weekday_id ) {
						this.daysAll = false;
						this.week_day_id = localSessionItems.weekday_id;
					}
					if ( 'filterProgrammeTags' in window.sessionStorage )
						this.scheduleTags     = JSON.parse( sessionStorage.getItem( 'filterProgrammeTags' ) ).prog_tags;
					if ( 'filterProgrammeSessions' in window.sessionStorage )
						this.scheduleSessions = JSON.parse( sessionStorage.getItem( 'filterProgrammeSessions' ) ).prog_sessions;					
					wp_params = {
						'slug' : localSessionItems.current_url,
					}
					this.back_to_url = localSessionItems.current_url;
				}  else {
					this.accountService.getCurrentSiwiSeason().then( ( response: any ) => {
						if ( response.status == 'Ok' ) {
							var is_conference;
							let current_season = response.current_season;
							if ( 'conference' == current_season )
								is_conference = true;
							else
								is_conference = false;
							let dot_params = {
								'id'           : current_slug_id,
								'is_conference' : is_conference,
							};
							this.accountService.getProgrameTagsSession( dot_params ).then( ( response: any ) => {
								this.scheduleTags     = response.tags;
								this.scheduleSessions = response.sessions;
							});
						}						
					});					
					if ( 'Exhibition' != this.content_type ) {
						wp_params = {
							'slug' : '/programme/schedule',
						}
					} else {
						wp_params = {
							'slug' : '/programme/exhibitors',
						}
					}
					this.back_to_url = wp_params.slug;
				}
				this.accountService.getBreadCrumb( wp_params ).then( ( response: any ) => {
					this.breadCrumbData = response.breadcrumb;
				});
			}		
			this.loadButton = false;
		});
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		location.reload();
	}

	ngOnInit() {
		var headerClass = document.getElementsByClassName( 'header');
		if ( ! headerClass[0].classList.contains( 'inner_page_menu' ) )
			headerClass[0].classList.add( 'inner_page_menu' );
	}
	/* popup for share */
	popupCenter = function( url, title, w, h ) {
		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
	    var left = ((width / 2) - (w / 2))/* + dualScreenLeft*/;
	    var top = ((height / 3) - (h / 3))/* + dualScreenTop*/;
	    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
	    // Puts focus on the newWindow
	    if (window.focus)
	        newWindow.focus();
	}

	filterMore( event : any, filter_type, filter_id, filter_name ) {
		sessionStorage.setItem( 'clickedName', JSON.stringify( filter_name ) );
		var tag_id;
		var tag_name;
		var filter_type_count;		
		if ( 'filterProgrammeKeys' in window.sessionStorage ) {
			let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterProgrammeKeys' ) );
			var url = localSessionItems.current_url;
			if ( url.includes( '?' ) )
				url = url.split( '?' )[0];			
			if ( 'tags' == filter_type ) {
				let tag_count       = localSessionItems.tag_count;
				if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
					if ( 0 != filter_id ) {
						url = url + '?tg=' + filter_id;
						this.showSelectedtags = true;
						this.tagsAll = false;
						filter_type_count = localSessionItems.filter_type_count + 1;
						tag_id = localSessionItems.filter_id;
						if ( tag_id != 0 ) {
							localSessionItems.tag_count = localSessionItems.tag_count + 1;
							tag_id = tag_id + ',' + filter_id;
							tag_name = localSessionItems.tag_names + ',' + filter_name;
							this.tag_list_name.push(filter_name);
							this.tag_list_id.push(filter_id);
						} else {
							localSessionItems.tag_count = 1;
							tag_id = filter_id;
							tag_name = filter_name;
							this.tag_list_name = filter_name;
							this.tag_list_id = filter_id;	
						}								
					} else {
						this.showSelectedtags = false;
						this.tagsAll = true;
						filter_type_count = localSessionItems.filter_type_count - localSessionItems.tag_count;
						tag_id = filter_id;
						localSessionItems.tag_count = 0;
						this.tag_list_id = [];
						this.tag_list_name = [];
					}
				} else {
					if ( 'opensession' != filter_name ) {
						url = url + '?gs=true';
						this.showSelectedgold = true;
						var goldstandard = '1';
					} else {
						url = url + '?os=true';
						this.showOpensession = true;
						var opensession = '1';
					}
					this.tag_list_name.push( filter_name );
					this.tag_list_id.push( filter_id );
				}
			} else {
				if ( localSessionItems.weekday_id != '0' )
					filter_type_count = localSessionItems.filter_type_count;
				else
					filter_type_count = localSessionItems.filter_type_count + 1;
				if ( 'weekday' == filter_type ) {
					if ( 0 != filter_id ) {
						url = url + '?dn=' + filter_id;
						this.showSelecteddays = true;
						this.daysAll = false;
						this.week_day_name = filter_name;
						this.week_day_id = filter_id;
					} else {
						this.showSelecteddays = false;
						this.daysAll = true;
						filter_type_count = localSessionItems.filter_type_count - 1;
						this.week_day_name = '';
						this.week_day_id = '';
					}
				} else {
					if ( 0 != filter_id ) {
						url = url + '?et=' + filter_id;
						this.showSelectedsession = true;
						this.sessionAll = false;
					} else {
						this.showSelectedsession = false;
						this.sessionAll = true;
					}
				}
				tag_id = filter_id;
			}
			let params = {
				'offset'            : 0,
				'type'              : localSessionItems.type,
				'search_option'     : localSessionItems.search_option,
				'search_text'       : localSessionItems.search_text,
				'filter_type'       : filter_type,
				'filter_id'         : filter_id,
				'filter_type_count' : filter_type_count,
			};
			/* update sessionStorage for search text */
			localSessionItems.offset = params.offset;
			localSessionItems.filter_type_count = filter_type_count;
			localSessionItems.filter_type = filter_type;
			if ( 'tags' == filter_type ) {
				if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
					localSessionItems.tag_id = filter_id;
					localSessionItems.filter_id = tag_id;
					localSessionItems.tag_names = tag_name;
				} else {
					if ( 'opensession' != filter_name )
						localSessionItems.goldstandard = goldstandard;
					else
						localSessionItems.opensession = opensession;
				}			
			} else if ( 'session' == filter_type )
				localSessionItems.session_id = filter_id;
	 		else if( 'weekday' == filter_type ) {
	 			localSessionItems.weekday_id = filter_id;
	 			localSessionItems.weekday_name = filter_name;
	 		}
			sessionStorage.setItem( 'filterProgrammeKeys', JSON.stringify( localSessionItems ) );
			this.router.navigateByUrl( url );
			/* session has add and remove from same click function */
		} else {
			if ( this.back_to_url.includes( '?' ) )
				this.back_to_url = this.back_to_url.split( '?' )[0];
			let goldstandard = 0;
			let opensession = 0;
			let session_id = 0;
			let weekday_id = 0;
			let tags_id = 0;
			let tag_count = 0;
			let tag_name = '';
			if ( 'tags' == filter_type ) {
				if ( 'goldstandard' != filter_name && 'opensession' != filter_name ) {
					if ( 0 != filter_id )
						this.back_to_url = this.back_to_url + '?tg=' + filter_id;
					tags_id = filter_id;
					tag_count = 1;
					tag_name = filter_name;
				} else {
					if ( 'opensession' != filter_name ) {
						this.back_to_url = this.back_to_url + '?gs=true';
						goldstandard = 1;
					} else {
						this.back_to_url = this.back_to_url + '?os=true';
						opensession = 1;
					}
				}			
			} else if ( 'session' == filter_type ) {
				if ( 0 != filter_id )
					this.back_to_url = this.back_to_url + '?et=' + filter_id;
				session_id = filter_id;
	 		} else if( 'weekday' == filter_type ) {
	 			if ( 0 != filter_id )
	 				this.back_to_url = this.back_to_url + '?dn=' + filter_id;
 			 	weekday_id = filter_id;
	 		}
			/* add to sessionStorage */
			let myObj = {
				offset            : 0,
				type              : 'event',
				search_option     : 'all',
				search_text       : 'null',
				view              : 'list',
				favourites        : 0,
				filter_type_count : 1, /* count how many filter clicked(tags, weekdays, goldstandard ) */
				tag_id            : tags_id, /* tag id of current clicked tag */
				session_id        : session_id, /* id of session clicked */
				weekday_id        : weekday_id, /* id of weekday clicked */
				filter_id         : tag_id, /* add tag id as array for multiple */
				tag_count         : tag_count, /* count how many tags clicked(tags only) */
				limit             : 50, /* data limit */
				goldstandard      : goldstandard, /* for goldstandard */
				opensession       : opensession, /* for opensession */
				tag_names         : tag_name,
			};
			sessionStorage.setItem( 'filterProgrammeKeys', JSON.stringify( myObj ) );
			let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterProgrammeKeys' ) );
			let params = {
				'offset'            : 0,
				'type'              : localSessionItems.type,
				'filter_type'       : filter_type,
				'filter_id'         : filter_id,
				'filter_type_count' : filter_type_count,
			};
			this.router.navigateByUrl( this.back_to_url );
		}	
	}

	backToSchedule( url ) {
		this._location.back();
	}

	receiveMessage($event) {
		this.scheduleDotNetData = $event;
	}
}